module.exports = __webpack_public_path__ + "img/limukani.31241a38.png";